import React, { useRef, useState, useEffect } from "react";
import * as yup from "yup";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import { Report, TonnageDisclaimer } from "../../../shared";

const schema = yup.object({
  StartingQuarter: yup.string().nullable(),
  EndingQuarter: yup.string().nullable(),
  RegId: yup.string().nullable(),
  EpaId: yup.string().nullable(),
});

export default function TqrSubmissionsReport() {
  const date = new Date;
  const location = useLocation();
  const params = queryString.parse(location.search);
  const searchOnInit = false;
  const [initialFormValues, setInitialFormValues] = useState({
    StartingQuarter: params && params.StartingQuarter ? params.StartingQuarter : undefined,
    EndingQuarter: params && params.EndingQuarter ? params.EndingQuarter : undefined,
    RegId: params && params.RegId ? params.RegId : undefined,
    EpaId: params && params.EpaId ? params.EpaId : undefined,
  });
  const [backToUrl, setBacktoUrl] = useState("/reports");
  const [pageTitle, setPageTitle] = useState("TQR Submitted by Transporter");
  const [apiEndpoint, setApiEndpoint] = useState(
    "/api/v1/hwts/search/tqrreport/submissions"
  );
  const [quarters, setQuarters] = useState([]);

  useEffect(() => {
    generateQuarters();
  }, [])

  const generateQuarters = () => {
    let quartersArr = [];
    for (var i = date.getFullYear(); i > 2001; i--) {
      for (var j = 4; j >= 1; j--) {
        let q = {
          label: `Q${j}, ${i}`,
          value: `${i}${j}`
        }
        quartersArr.push(q);
      }
    }
    setQuarters(quartersArr);
  }

  const formConfig = [
    {
      name: "StartingQuarter",
      config: {
        col: "md",
        validate: true,
        colWidth: "2",
        label: "Starting Quarter",
        placeholder: "Select a Year",
        type: "select3",
        data: quarters,
      },
    },
    {
      name: "EndingQuarter",
      config: {
        col: "md",
        validate: true,
        colWidth: "2",
        label: "Ending Quarter",
        placeholder: "Select a Year",
        type: "select3",
        data: quarters,
      },
    },
    {
      name: "RegId",
      config: {
        col: "md",
        colWidth: "3",
        label: "Transporter Registration ID",
        placeholder: "Enter a Registration ID...",
        type: "text",
      },
    },
    {
      name: "EpaId",
      config: {
        col: "md",
        colWidth: "2",
        label: "Transporter ID Number",
        placeholder: "Enter an ID Number...",
        type: "text",
      },
    },
  ];

  const customColumnDefs = [
    {
      headerName: "Quarter",
      field: "TQR_RPT_NUM",
      sortable: true,
      width: 40
    },
    {
      headerName: "Submission Date",
      field: "CREATE_DATE",
      sortable: true,
      width: 60
    },
    {
      headerName: "Reg ID",
      field: "REGN_ID",
      sortable: true,
      cellRenderer: function (params) {
        if (params.value != null) {
          return (
            `<a href="/reports/transporter/${params.value}" target="_">` +
            params.value +
            "</a>"
          );
        }
      },
      width: 40
    },
    {
      headerName: "Transporter Name",
      field: "TRANS_NAME",
      sortable: true,
    },
    {
      headerName: "Transporter ID Number",
      field: "TRANS_EPA_ID",
      sortable: true,
      cellRenderer: function (params) {
        if (params.value != null) {
          return (
            `<a href="/facility/${params.value}" target="_">` +
            params.value +
            "</a>"
          );
        }
      },
      width: 70
    },
    {
      headerName: "Terminal Address",
      field: "TERMINAL_ADDRESS",
      sortable: true,
    },
    {
      headerName: "Number of Generators",
      field: "CNT_GENS",
      sortable: true,
      width: 50
    },
  ]

  const reportDescription = (
    <p>
      Provides a list of TQR Quarterly reports submitted for each Transporter.
    </p>
  )

  return (
    quarters.length > 1 ?
      <>
        <Report
          breadcrumb={[
            { name: "HWTS Reports", url: "/reports", active: false },
            { name: pageTitle, url: "", active: true },
          ]}
          backToUrl={backToUrl}
          pageTitle={pageTitle}
          initialFormValues={initialFormValues}
          schema={schema}
          formConfig={formConfig}
          apiEndpoint={apiEndpoint}
          customColumnDefs={customColumnDefs}
          searchOnInit={searchOnInit}
          initialPageSize={25}
        //reportDescription={reportDescription}
        />
        <div className="container">
          <TonnageDisclaimer />
        </div>
      </> : null
  );
}